import styled from '@emotion/styled';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';

import { Z_INDEX } from '@/components/shared/constants/zIndex';

type ToastSeverity = 'success' | 'error';

// PrimeReact stacks overlays by open order, so a drawer opened after a toast would cover it.
// Pin toasts to their own layer instead; `baseZIndex` would also push later overlays above the header.
export const LayeredToast = styled(Toast)`
    z-index: ${Z_INDEX.TOAST} !important;
`;

// Bottom-right status toast. PrimeReact's default 3s `life` auto-dismisses it.
export const useToast = (testId?: string) => {
    const toastRef = useRef<Toast>(null);

    // Replace rather than stack, so only the latest action's outcome is shown.
    const showToast = (severity: ToastSeverity, summary: string) => {
        toastRef.current?.replace({ severity, summary });
    };

    const toast = (
        <LayeredToast
            ref={toastRef}
            position="bottom-right"
            appendTo={document.body}
            data-testid={testId}
        />
    );

    return { toast, showToast };
};
